export default __webpack_public_path__ + "08f34d1a60300cde6de60988fdb4fc25.bin";